var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-right",on:{"click":function($event){$event.stopPropagation();}}},[_c('OverflowMenu',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }